import React from 'react';
import { Link } from "react-router-dom";
import './wedding-tour.css';

function WeddingTour() {
  return (
    <section className="wedding-tour" aria-labelledby="wedding-tour-heading">
      <div className="wedding-container">
        {/* Hero Section */}
        <div className="wedding-hero">
          <div className="wedding-hero-content">
            <h1 id="wedding-tour-heading" className="wedding-hero-title">
              Luxury Wedding Transportation Services
            </h1>
            <p className="wedding-hero-description">
              Make your special day unforgettable with our premium wedding transportation. 
              Elegant vehicles, professional chauffeurs, and seamless service for the perfect wedding experience.
            </p>
            <div className="wedding-hero-buttons">
                 <Link to="/bookings">
              <button className="wedding-cta-button primary">Book Wedding Package</button></Link>
           
            </div>
            <div className="wedding-stats">
              <div className="wedding-stat-item">
                <div className="wedding-stat-number">1000+</div>
                <div className="wedding-stat-label">Weddings Served</div>
              </div>
              <div className="wedding-stat-item">
                <div className="wedding-stat-number">50+</div>
                <div className="wedding-stat-label">Luxury Vehicles</div>
              </div>
              <div className="wedding-stat-item">
                <div className="wedding-stat-number">99%</div>
                <div className="wedding-stat-label">Happy Couples</div>
              </div>
            </div>
          </div>
          <div className="wedding-hero-image">
            <img 
              src="/wedding tour retionz.png" 
              alt="Luxury wedding car decorated with flowers for bride and groom transportation"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Wedding Packages */}
        <div className="wedding-packages-section">
          <h2 className="wedding-section-title">Exclusive Wedding Packages</h2>
          <div className="wedding-packages-grid">
            <div className="wedding-package-card">
              <div className="package-header">
                <h3>Classic Wedding</h3>
                <div className="package-price">$ 99</div>
              </div>
              <div className="package-content">
                <p>Perfect for intimate weddings and budget-conscious couples</p>
                <ul className="package-features">
                  <li>✓ Luxury Sedan (6 hours)</li>
                  <li>✓ Bride & Groom Service</li>
                  <li>✓ Basic Decoration</li>
                  <li>✓ Professional Chauffeur</li>
                  <li>✓ 50 km coverage</li>
                </ul>
                <div className="vehicle-options">
                  <span className="vehicle-option">Mercedes E-Class</span>
                  <span className="vehicle-option">BMW 5 Series</span>
                </div>
                  <Link to="/bookings">
                <button className="package-book-btn">Select Classic</button></Link>
              </div>
            </div>

            <div className="wedding-package-card featured">
              <div className="popular-badge">Most Popular</div>
              <div className="package-header">
                <h3>Premium Wedding</h3>
                <div className="package-price">$ 249</div>
              </div>
              <div className="package-content">
                <p>Comprehensive package for the complete wedding experience</p>
                <ul className="package-features">
                  <li>✓ Luxury Limousine (8 hours)</li>
                  <li>✓ Bride, Groom & Family</li>
                  <li>✓ Premium Decoration</li>
                  <li>✓ VIP Chauffeur</li>
                  <li>✓ 100 km coverage</li>
                  <li>✓ Red Carpet Service</li>
                </ul>
                <div className="vehicle-options">
                  <span className="vehicle-option">Mercedes S-Class</span>
                  <span className="vehicle-option">BMW 7 Series</span>
                </div>
                 <Link to="/bookings">
                <button className="package-book-btn">Select Premium</button></Link>
              </div>
            </div>

            <div className="wedding-package-card">
              <div className="package-header">
                <h3>Royal Wedding</h3>
                <div className="package-price">$ 499</div>
              </div>
              <div className="package-content">
                <p>Ultimate luxury experience for your dream wedding</p>
                <ul className="package-features">
                  <li>✓ Super Luxury Car (12 hours)</li>
                  <li>✓ Complete Wedding Party</li>
                  <li>✓ Royal Decoration</li>
                  <li>✓ Executive Chauffeur</li>
                  <li>✓ Unlimited Distance</li>
                  <li>✓ Champagne Service</li>
                  <li>✓ Photo Session</li>
                </ul>
                <div className="vehicle-options">
                  <span className="vehicle-option">Rolls Royce</span>
                  <span className="vehicle-option">Bentley</span>
                </div>
                 <Link to="/bookings">
                <button className="package-book-btn">Select Royal</button></Link>
              </div>
            </div>
          </div>
        </div>



        {/* Wedding Services */}
        <div className="wedding-services-section">
          <h2 className="wedding-section-title">Complete Wedding Services</h2>
          <div className="wedding-services-grid">
            <div className="wedding-service-card">
              <div className="service-icon"></div>
              <h3>Bride Service</h3>
              <p>Special attention for the bride with careful handling of wedding dress and accessories</p>
              <ul>
                <li>Early pickup for preparations</li>
                <li>Dress-friendly vehicle space</li>
                <li>Female chauffeur available</li>
              </ul>
            </div>
            <div className="wedding-service-card">
              <div className="service-icon"></div>
              <h3>Groom Service</h3>
              <p>Punctual and reliable service for the groom and groomsmen</p>
              <ul>
                <li>On-time ceremony arrival</li>
                <li>Space for groomsmen</li>
                <li>Professional coordination</li>
              </ul>
            </div>
            <div className="wedding-service-card">
              <div className="service-icon"></div>
              <h3>Family Service</h3>
              <p>Comfortable transportation for immediate family members</p>
              <ul>
                <li>Multiple vehicle options</li>
                <li>Elderly-friendly vehicles</li>
                <li>Child seat availability</li>
              </ul>
            </div>
            <div className="wedding-service-card">
              <div className="service-icon"></div>
              <h3>Guest Service</h3>
              <p>Coordinated transportation for wedding guests</p>
              <ul>
                <li>Shuttle services</li>
                <li>Group transportation</li>
                <li>Hotel to venue transfer</li>
              </ul>
            </div>
          </div>
        </div>




        {/* Luxury Fleet */}
        <div className="fleet-section">
          <h2 className="wedding-section-title">Our Luxury Wedding Fleet</h2>
          <div className="fleet-grid">
            <div className="fleet-card">
              <div className="fleet-image">
                <img 
                  src="/benz.jpeg" 
                  alt="Luxury wedding sedan Mercedes E-Class for classic weddings"
                  loading="lazy"
                  width="300"
                  height="200"
                />
              </div>
              <div className="fleet-content">
                <h3>Executive Sedans</h3>
                <p>Mercedes E-Class, BMW 5 Series, Audi A6</p>
                <div className="fleet-features">
                  <span>Leather Seats</span>
                  <span>Climate Control</span>
                  <span>Spacious Interior</span>
                </div>
              </div>
            </div>
            <div className="fleet-card">
              <div className="fleet-image">
                <img 
                  src="/lexus.jpg" 
                  alt="Premium wedding limousine for luxury wedding transportation"
                  loading="lazy"
                  width="300"
                  height="200"
                />
              </div>
              <div className="fleet-content">
                <h3>Luxury Limousines</h3>
                <p>Mercedes S-Class, BMW 7 Series, Lexus LS</p>
                <div className="fleet-features">
                  <span>Extended Length</span>
                  <span>Premium Sound</span>
                  <span>VIP Interior</span>
                </div>
              </div>
            </div>
            <div className="fleet-card">
              <div className="fleet-image">
                <img 
                  src="/rollroyce.png" 
                  alt="Super luxury wedding car Rolls Royce for royal weddings"
                  loading="lazy"
                  width="300"
                  height="200"
                />
              </div>
              <div className="fleet-content">
                <h3>Super Luxury</h3>
                <p>Rolls Royce, Bentley, Maybach</p>
                <div className="fleet-features">
                  <span>Handcrafted Interior</span>
                  <span>Champagne Service</span>
                  <span>Royal Experience</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Decoration Options */}
        <div className="decoration-section">
          <div className="decoration-content">
            <h2 className="wedding-section-title">Wedding Decoration Packages</h2>
            <p className="decoration-description">
              Make your wedding car as beautiful as your special day with our exclusive decoration options
            </p>
            <div className="decoration-options">
              <div className="decoration-option">
                <div className="decoration-name">Classic Decor</div>
                <div className="decoration-price">$49</div>
                <ul>
                  <li>Ribbon decoration</li>
                  <li>Basic flower arrangement</li>
                  <li>Just Married sign</li>
                </ul>
              </div>
              <div className="decoration-option featured">
                <div className="popular-badge">Most Chosen</div>
                <div className="decoration-name">Premium Decor</div>
                <div className="decoration-price">$99</div>
                <ul>
                  <li>Fresh flower decoration</li>
                  <li>Premium ribbon work</li>
                  <li>Custom signage</li>
                  <li>Interior flowers</li>
                </ul>
              </div>
              <div className="decoration-option">
                <div className="decoration-name">Royal Decor</div>
                <div className="decoration-price">$199</div>
                <ul>
                  <li>Luxury flower arrangements</li>
                  <li>Gold/Silver themes</li>
                  <li>Full vehicle makeover</li>
                  <li>Professional photos</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Booking Process */}
        <div className="wedding-booking-process">
          <h2 className="wedding-section-title">Simple Wedding Booking Process</h2>
          <div className="booking-steps">
            <div className="booking-step">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3>Consultation</h3>
                <p>Discuss your wedding schedule, locations, and specific requirements</p>
              </div>
            </div>
            <div className="booking-step">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3>Vehicle Selection</h3>
                <p>Choose from our luxury fleet and decoration options</p>
              </div>
            </div>
            <div className="booking-step">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3>Finalize Details</h3>
                <p>Confirm timing, locations, and special instructions</p>
              </div>
            </div>
            <div className="booking-step">
              <div className="step-number">04</div>
              <div className="step-content">
                <h3>Relax & Enjoy</h3>
                <p>Leave the transportation to us and focus on your special day</p>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="testimonials-section">
          <h2 className="wedding-section-title">What Couples Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                "Our wedding transportation was absolutely perfect! The luxury limousine arrived on time and the decoration was stunning. Highly recommended!"
              </div>
              <div className="testimonial-author">
                <div className="author-name">Sarah & Michael</div>
                <div className="wedding-date">March 15, 2024</div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                "Professional service from start to finish. The chauffeur was excellent and handled all our family members with care. Made our day stress-free!"
              </div>
              <div className="testimonial-author">
                <div className="author-name">Jennifer & David</div>
                <div className="wedding-date">February 28, 2024</div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="wedding-cta-section">
          <div className="wedding-cta-content">
            <h2>Ready to Plan Your Perfect Wedding Transportation?</h2>
            <p>Contact us today for a personalized consultation and make your wedding day truly memorable</p>
            <div className="wedding-cta-buttons">
               <Link to="/bookings">
              <button className="wedding-cta-button large primary">Book Consultation</button></Link>

             <a href="tel:+94701707707" className="wedding-call-link">
  <button className="wedding-cta-button large secondary">
    Call Now: +94 70 170 7707
  </button>
</a>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WeddingTour;